import { BrowserModule } from '@angular/platform-browser';
import { provideNoopAnimations } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { ChartDistributionComponent } from './components/chart-distribution/chart-distribution.component';
import { ChartTimeseriesComponent } from './components/chart-timeseries/chart-timeseries.component';
import { ChartComparisonComponent } from './components/chart-comparison/chart-comparison.component';
import './components/chart-comparison/comparison-bar.chart';
import { MapComponent } from './components/map/map.component';
import { CrowdsourcingPageComponent } from './pages/crowdsourcing-page/crowdsourcing-page.component';
import { HeaderComponent } from './components/header/header.component';
import { HomePageComponent } from './pages/home-page/home-page.component';
import { LoginPageComponent } from './pages/login-page/login-page.component';
import { BarometerPageComponent } from './pages/barometer-page/barometer-page.component';
import { MapLegendComponent } from './components/map-legend/map-legend.component';
import { ExtractInfoComponent } from './components/extract-info/extract-info.component';
import { ProjectLayoutComponent } from './pages/project-layout/project-layout.component';
import { FooterComponent } from './components/footer/footer.component';
import { ChartFiltersComponent } from './components/abstract-chartjs/chart-filters/chart-filters.component';
import { MapFiltersComponent } from './components/map/map-filters/map-filters.component';
import { StoreBadgeComponent } from './components/store-badge/store-badge.component';
import { NavLinkComponent } from './components/nav-link/nav-link.component';
import { LangRouterLinkDirective } from './directives/lang-router-link.directive';
import { SidenavCloseDirective } from './directives/sidenav-close.directive';
import { LanguageSelectorComponent } from './components/language-selector/language-selector.component';
import { ApplicationsPageComponent } from './pages/applications-page/applications-page.component';
import { DownloadAppBannerComponent } from './pages/download-app-banner/download-app-banner.component';
import { DataDescriptionComponent } from './components/data-description/data-description.component';
import '../../node_modules/moment/locale/de.js';
import '../../node_modules/moment/locale/fr.js';
import '../../node_modules/moment/locale/nl.js';
import { TermsPageComponent } from './pages/terms-page/terms-page.component';
import { LoaderComponent } from './components/loader/loader.component';
import { IsBrowserDirective } from './directives/is-browser.directive';
import { AtlasPageComponent } from './pages/atlas-page/atlas-page.component';
import { DataPageComponent } from './pages/data-page/data-page.component';
import { SharedModule } from './_shared/shared.module';


@NgModule({
    imports: [
        // Angular
        BrowserModule, // Angular Universal
        AppRoutingModule,
        SharedModule,
    ],
    declarations: [
        AppComponent,
        ChartDistributionComponent,
        ChartTimeseriesComponent,
        ChartComparisonComponent,
        MapComponent,
        CrowdsourcingPageComponent,
        HeaderComponent,
        HomePageComponent,
        LoginPageComponent,
        BarometerPageComponent,
        TermsPageComponent,
        MapLegendComponent,
        ExtractInfoComponent,
        ProjectLayoutComponent,
        FooterComponent,
        ChartFiltersComponent,
        MapFiltersComponent,
        StoreBadgeComponent,
        NavLinkComponent,
        LangRouterLinkDirective,
        SidenavCloseDirective,
        LanguageSelectorComponent,
        ApplicationsPageComponent,
        DownloadAppBannerComponent,
        DataDescriptionComponent,
        LoaderComponent,
        IsBrowserDirective,
        AtlasPageComponent,
        DataPageComponent,
    ],
    providers: [provideHttpClient(withFetch()), provideNoopAnimations()],
    bootstrap: [AppComponent],
})
export class AppModule {}







